import { connect } from "react-redux";
import WalletApprovalListing from "./Transactions";
import { bindActionCreators } from "redux";
import {approvalList} from "../../../services/redux/Wallet/action";

const mapStateToProps = (state) => ({
    approvalListDetails : state.Wallet.approvalList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        approvalList
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WalletApprovalListing);